import { foundersImage } from "@/mocks/homeData";
import { GOOGLE_RATING_LABEL } from "@/pages/home/googleStats";

const ABOUT_HIGHLIGHTS = [
  "Atendimento personalizado, do primeiro contato ao fim do passeio",
  "Mais de 12 anos de experiência no Lago de Furnas",
  "Segurança em primeiro lugar, com embarcações regulamentadas",
  "Frota própria, moderna e confortável",
  "Equipe local que conhece cada canto de Capitólio",
];

export default function About() {
  return (
    <section id="sobre" className="relative py-7 md:py-9 bg-background-100 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-[1500px] mx-auto">
          <div className="flex flex-col">
            <div className="text-center reveal mb-6 md:mb-8">
              <span className="inline-block text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em] text-accent-700 mb-3">
                Nossa história
              </span>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-900 tracking-tight">
                Quem Somos: Eco Tour Turismo em Capitólio
              </h2>
            </div>

            <div className="reveal">
              <div className="relative rounded-xl overflow-hidden mx-auto w-full max-w-[520px]">
                <img
                  src={foundersImage}
                  alt="Equipe da Eco Tour Turismo reunida em frente ao letreiro de Capitólio, no Lago de Furnas"
                  title="Equipe Eco Tour Turismo em Capitólio"
                  className="w-full h-auto object-cover object-center"
                />
                <div className="absolute bottom-3 left-1/2 -translate-x-1/2 rounded-full bg-background-50/95 backdrop-blur px-3.5 py-1.5">
                  <p className="text-[11px] md:text-xs font-heading font-bold text-primary-900 whitespace-nowrap">
                    Equipe Eco Tour Turismo
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-6 md:mt-8 grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 reveal reveal-delay-2">
              <div>
                <p className="text-sm md:text-base font-semibold text-primary-700 leading-relaxed mb-2">
                  Muito mais que passeios: experiências inesquecíveis!
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  A Eco Tour Turismo é uma empresa que valoriza o atendimento próximo, a confiança e a
                  paixão por compartilhar as belezas do Mar de Minas. Trabalhamos para proporcionar
                  experiências únicas, com profissionalismo, dedicação e atenção a cada detalhe, para que
                  você aproveite Capitólio com tranquilidade e segurança.
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Aqui, cada cliente é recebido com carinho e cada passeio é uma oportunidade de criar boas
                  lembranças!
                </p>
              </div>

              <div>
                <p className="text-sm text-foreground-700 font-semibold mb-3">O que faz a nossa diferença:</p>
                <ul className="space-y-2 mb-4">
                  {ABOUT_HIGHLIGHTS.map((item) => (
                    <li key={item} className="flex items-center gap-2.5 text-sm text-foreground-700">
                      <span className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-accent-700 text-xs" />
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
                <div className="flex flex-nowrap items-center gap-3 md:gap-4">
                  <div className="flex items-baseline gap-1.5 whitespace-nowrap">
                    <span className="font-heading text-lg md:text-xl font-bold text-primary-500">+12</span>
                    <span className="text-[11px] md:text-xs text-foreground-500">anos</span>
                  </div>
                  <span className="w-px h-6 bg-background-300/70 flex-shrink-0" />
                  <div className="flex items-baseline gap-1.5 whitespace-nowrap">
                    <span className="font-heading text-lg md:text-xl font-bold text-primary-500">+10.000</span>
                    <span className="text-[11px] md:text-xs text-foreground-500">clientes</span>
                  </div>
                  <span className="w-px h-6 bg-background-300/70 flex-shrink-0" />
                  <div className="flex items-baseline gap-1.5 whitespace-nowrap">
                    <span className="font-heading text-lg md:text-xl font-bold text-primary-500">{GOOGLE_RATING_LABEL}</span>
                    <span className="text-[11px] md:text-xs text-foreground-500">avaliações</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}